import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
console.log('Forcing hash:', process.env.REACT_APP_FORCE_HASH);
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
